var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import CardDefault from './card-default';
import CardDynamic from './card-dynamic';
import CardEmoji from './card-emoji';
import CardFollow from './card-follow';
import CardImage from './card-image';
import CardVideo from './card-video';
import CardOrder from './card-order';
import CardProduct from './card-product';
import CardRefund from './card-refund';
import CardSystem from './card-system';
import CardText from './card-text';
import CardVoucher from './card-voucher';
import CardResend from './card-resend';
import CardUnpaidOrder from './card-unpaid-order';
import CardAction from './card-action';
import CardConfirmOrder from './card-confirm-order';
import CardUnpaidAndA2C from './card-unpaid';
import CardProductConfirm from './card-product-confirm';
import CardProductSelectSku from './card-product-sku';
var TemplateTypeCode = {
    CardResend: 0,
    CardText: 1,
    CardSystem: 2,
    CardImage: 3,
    CardEmoji: 4,
    CardVideo: 5,
    CardDynamic: -5,
    CardProduct: 10006,
    CardProductConfirm: 10024,
    CardProductSelectSku: 10025,
    CardOrder: 10007,
    CardVoucher: 10008,
    CardFollow: 10010,
    CardRefund: 10011,
    CardAction: 10012,
    CardUnpaidOrder: 10014,
    CardUnpaid: 200008,
    CardAddToCart: 200009,
};
var TemplateTypeMap = new Map()
    .set(TemplateTypeCode.CardResend, CardResend)
    .set(TemplateTypeCode.CardText, CardText)
    .set(TemplateTypeCode.CardSystem, CardSystem)
    .set(TemplateTypeCode.CardImage, CardImage)
    .set(TemplateTypeCode.CardVideo, CardVideo)
    .set(TemplateTypeCode.CardEmoji, CardEmoji)
    .set(TemplateTypeCode.CardDynamic, CardDynamic)
    .set(TemplateTypeCode.CardProduct, CardProduct)
    .set(TemplateTypeCode.CardProductConfirm, CardProductConfirm)
    .set(TemplateTypeCode.CardProductSelectSku, CardProductSelectSku)
    .set(TemplateTypeCode.CardOrder, CardOrder)
    .set(TemplateTypeCode.CardVoucher, CardVoucher)
    .set(TemplateTypeCode.CardFollow, CardFollow)
    .set(TemplateTypeCode.CardRefund, CardRefund)
    .set(TemplateTypeCode.CardAction, CardAction)
    .set(TemplateTypeCode.CardUnpaidOrder, CardUnpaidOrder)
    .set(TemplateTypeCode.CardUnpaid, CardUnpaidAndA2C)
    .set(TemplateTypeCode.CardAddToCart, CardUnpaidAndA2C)
    .set('default', CardDefault);
var CardTypeCode = {
    CardResend: 0,
    CardText: 1,
    CardSystem: 2,
    CardImage: 3,
    CardEmoji: 4,
    CardVideo: 5,
    CardDynamic: -5,
    CardProduct: 10003,
    CardProductConfirm: 10024,
    CardProductSelectSku: 10025,
    CardOrder: 10004,
    CardVoucher: 10005,
    CardFollow: 10007,
    CardRefund: 10008,
    CardWhereOrder: 10009,
    CardConfirmOrder: 10010,
    CardUnpaidOrder: 10011,
    CardAction: 10012,
    CardUnpaid: 200008,
    CardAddToCart: 200009,
};
var CardTypeName = {
    0: 'card-resend',
    1: 'card-text',
    2: 'card-system',
    3: 'card-image',
    4: 'card-emoji',
    5: "card-video",
    10003: 'card-product',
    10024: 'card-product-confirm',
    10025: 'card-product-sku',
    10004: 'card-order',
    10005: 'card-voucher',
    10007: 'card-follow',
    10008: 'card-refund',
    10009: 'card-where-order',
    10010: 'card-confirm-order',
    10011: 'card-unpaid-order',
    10012: 'card-action',
    200008: 'card-unpaid',
    200009: 'card-unpaid',
};
var CardTypeMap = new Map()
    .set(CardTypeCode.CardResend, CardResend)
    .set(CardTypeCode.CardText, CardText)
    .set(CardTypeCode.CardSystem, CardSystem)
    .set(CardTypeCode.CardImage, CardImage)
    .set(CardTypeCode.CardVideo, CardVideo)
    .set(CardTypeCode.CardEmoji, CardEmoji)
    .set(CardTypeCode.CardDynamic, CardDynamic)
    .set(CardTypeCode.CardProduct, CardProduct)
    .set(CardTypeCode.CardProductConfirm, CardProductConfirm)
    .set(CardTypeCode.CardProductSelectSku, CardProductSelectSku)
    .set(CardTypeCode.CardOrder, CardOrder)
    .set(CardTypeCode.CardVoucher, CardVoucher)
    .set(CardTypeCode.CardFollow, CardFollow)
    .set(CardTypeCode.CardRefund, CardRefund)
    .set(CardTypeCode.CardAction, CardAction)
    .set(CardTypeCode.CardUnpaidOrder, CardUnpaidOrder)
    .set(TemplateTypeCode.CardUnpaid, CardUnpaidAndA2C)
    .set(TemplateTypeCode.CardAddToCart, CardUnpaidAndA2C)
    .set('default', CardDefault);
if (window.location.hostname.indexOf('aliexpress') > -1) {
    CardTypeMap.set(CardTypeCode.CardConfirmOrder, CardConfirmOrder);
}
export function registerCard(option) {
    var e_1, _a;
    if (!Array.isArray(option)) {
        option = [option];
    }
    try {
        for (var option_1 = __values(option), option_1_1 = option_1.next(); !option_1_1.done; option_1_1 = option_1.next()) {
            var _b = option_1_1.value, key = _b.key, code = _b.code, name_1 = _b.name, component = _b.component;
            CardTypeName[key] = code;
            CardTypeName[code] = name_1;
            CardTypeMap.set(code, component);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (option_1_1 && !option_1_1.done && (_a = option_1.return)) _a.call(option_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
export function registerTemplate(option) {
    var e_2, _a;
    if (!Array.isArray(option)) {
        option = [option];
    }
    try {
        for (var option_2 = __values(option), option_2_1 = option_2.next(); !option_2_1.done; option_2_1 = option_2.next()) {
            var _b = option_2_1.value, key = _b.key, code = _b.code, component = _b.component;
            TemplateTypeCode[key] = code;
            TemplateTypeMap.set(code, component);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (option_2_1 && !option_2_1.done && (_a = option_2.return)) _a.call(option_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
export { TemplateTypeMap, CardTypeMap, CardDefault, TemplateTypeCode, CardTypeCode, CardTypeName };

//# sourceMappingURL=card-map.js.map
